/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateMerchantAppData} from '../api'

export const useMutationUpdateMerchantAppData = createReactQueryMutationHook('updateMerchantAppData', updateMerchantAppData)
